type StoreCitySidebarProps = {
  cities: string[];
  selectedCity: string;
  onSelectCity: (city: string) => void;
};

export function StoreCitySidebar({ cities, selectedCity, onSelectCity }: StoreCitySidebarProps) {
  return (
    <nav
      className="h-full overflow-y-auto border-r border-gray-200 bg-white"
      aria-label="Store cities"
    >
      <ul className="divide-y divide-gray-100">
        {cities.map((city) => {
          const isActive = city === selectedCity;
          return (
            <li key={city}>
              <button
                type="button"
                onClick={() => onSelectCity(city)}
                className={`w-full px-5 py-3 text-left text-sm transition-colors ${
                  isActive
                    ? 'bg-[#f0f4f8] font-semibold text-[#1a3a5c]'
                    : 'text-gray-700 hover:bg-gray-50'
                }`}
                aria-current={isActive ? 'true' : undefined}
              >
                {city}
              </button>
            </li>
          );
        })}
      </ul>
    </nav>
  );
}
